import { environnement } from "configs/environnement";
import api from "./api";
import {
  IContributionTypeResponse,
  ISaveContributionType,
  IUpdateContributionType,
} from "models/church.types";

const BASE_URL = `${environnement.baseURL}/contribution-types`;

export const ContributionTypeService = {
  /**
   * Récupérer la liste complète des types de contribution (paginée)
   * Utilise la route de recherche sans query pour tout récupérer
   */
  getAll: async (page: number, size: number) => {
    const response = await api.get<IContributionTypeResponse[]>(
      `${BASE_URL}/_search`,
      {
        params: {
          page: page,
          size: size,
          sort: "id,desc",
        },
      },
    );
    return {
      data: response.data,
      totalCount: parseInt(response.headers["x-total-count"] || "0"),
    };
  },

  /**
   * la liste complète sans pagination
   * Utile pour les Select dans les formulaires de contributions
   */
  getAllSimple: async (): Promise<IContributionTypeResponse[]> => {
    const response = await api.get<IContributionTypeResponse[]>(
      `${BASE_URL}/_search`,
      {
        params: {
          page: 0,
          size: 1000,
          sort: "name,asc",
        },
      },
    );
    return response.data;
  },

  /**
   * Créer un nouveau type de contribution
   */
  create: async (
    contributionType: ISaveContributionType,
  ): Promise<IContributionTypeResponse> => {
    const response = await api.post<IContributionTypeResponse>(
      `${BASE_URL}`,
      contributionType,
    );
    return response.data;
  },

  /**
   * Mettre à jour un type de contribution existant
   */
  update: async (
    contributionType: IUpdateContributionType,
  ): Promise<IContributionTypeResponse> => {
    const response = await api.put<IContributionTypeResponse>(
      `${BASE_URL}`,
      contributionType,
    );
    return response.data;
  },

  /**
   * Récupérer un type de contribution par son ID
   */
  getById: async (id: number): Promise<IContributionTypeResponse> => {
    const response = await api.get<IContributionTypeResponse>(
      `${BASE_URL}/${id}`,
    );
    return response.data;
  },

  /**
   * Supprimer un type de contribution
   */
  delete: async (id: number): Promise<void> => {
    await api.delete(`${BASE_URL}/${id}`);
  },

  /**
   * Rechercher des types de contribution par mot-clé
   */
  search: async (query: string, page: number, size: number) => {
    const response = await api.get<IContributionTypeResponse[]>(
      `${BASE_URL}/_search`,
      {
        params: {
          query: query,
          page: page,
          size: size,
          sort: "id,desc",
        },
      },
    );
    return {
      data: response.data,
      totalCount: parseInt(response.headers["x-total-count"] || "0"),
    };
  },
};
